import { Avatar, Typography } from "@material-ui/core";
import QuestionMarks from "../../../assets/icons/Question.png";
import CheckMark from "../../../assets/icons/checkMark.png";
import "./QueueCards/BookScreenQueueCard.scss";
import { useSelector } from "react-redux";
import { RootState } from "../../../state/configureStore";

interface QueueCardProps {
  pageTitle: string;
  audioPath?: string;
  id: string;
  onClick: (questionId: string) => void;
}

const BookScreenComprehensionCard = (props: QueueCardProps) => {
  const state = useSelector((state: RootState) => state.bookScreenState);
  const isActive = props.id === state.currentQuestionId;
  const className = `${props.audioPath ? "submitted" : "queue"}Card ${isActive ? "active" : ""}`;

  return (
    <div className={className} onClick={() => props.onClick(props.id)}>
      <Avatar className={props.audioPath ? "circleCheckMark" : "circleQuestionIcon"}>
        <img src={props.audioPath ? CheckMark : QuestionMarks} alt="Question mark" className="circleImage" />
      </Avatar>
      <div>
        <Typography className="pageTitle">{props.pageTitle}</Typography>
      </div>
    </div>
  );
};

export default BookScreenComprehensionCard;
